;(function() {
  'use strict'

  angular.module('core.contentPanel', [])
})()
